import script from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=1dbd970c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbd970c"]])

export default __exports__